<template>
  <el-autocomplete class="inline-input" v-model="providerName" :fetch-suggestions="querySearchAsync" placeholder="请输入合作公司名称" @select="handleSelect" :trigger-on-focus="false" :debounce="500"></el-autocomplete>
</template>
<script>
  export default {
    name: 'providerautocomplete',
    data() {
      return {
        providerName: ''
      }
    },
    watch: {
      providerName: function() {
        if(this.providerName == '') {
          this.$emit('callBack', '')
        }
      }
    },
    methods: {
      //根据姓名或登录账户查询淘金客信息
      querySearchAsync(queryString, callback) {
        if((queryString !== '') && (queryString.length >= 2)) {
          var list = []
          var data = {
            'providerName': queryString
          }
          this.$http.post(API_ROOT.provider + '/providerInfo/queryList', data).then(response => {
            var result = response.data
            if(result.success) {
              this.success = result.success
              this.message = result.msg
              //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
              for(let i of response.data.data) {
                i.value = i.providerName
              }
              list = result.data
              callback(list)
            }else {
              alert(result.msg)
            }
          }, response => {
            alert('网络繁忙，请稍后重试！')
          })
        }
      },
      handleSelect(item) {
        this.$emit('callBack', item.providerId)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ./src/components/providerAutoComplete.vue